import { ApiProperty } from "@nestjs/swagger";
import { ChildLotsInfoDto } from "./child-lots-info";
import { OperationTypeEnum } from "@gtpl/shared-models/common-models";
export class LotClubbingDto {
    @ApiProperty()
    mainlotNo: string;
    @ApiProperty()
    operation:OperationTypeEnum;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    soItemId: number;
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    subPlantId: number;
    @ApiProperty()
    purpose:string;
    @ApiProperty()
    remarks:string;
    @ApiProperty()
    subLotInfo:ChildLotsInfoDto[];
    @ApiProperty()
    availableQuantity:number;
    @ApiProperty()
    createdUser:string;
    @ApiProperty()
    prevOperation:OperationTypeEnum;
    @ApiProperty()
    count: number
    @ApiProperty()
    qtyAftClub:number
}